import { Heart, Users, Book } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useSiteContent } from "@/hooks/useSiteContent";

const About = () => {
  const { t } = useLanguage();
  const { content } = useSiteContent('about');
  
  return (
    <section id="about" className="py-20 bg-card">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            {content.title || t("about.title")}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {content.subtitle || t("about.subtitle")}
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-6 text-muted-foreground text-lg">
          {/* Regular text content */}
          {Object.keys(content)
            .filter(key => key.startsWith('text'))
            .sort()
            .map(key => (
              <p key={key} className="whitespace-pre-line">
                {content[key] || t(`about.${key}`)}
              </p>
            ))}
          
          {/* Bulleted content */}
          {(() => {
            const bulletedGroups: { [key: string]: { heading: string; texts: string[] } } = {};
            
            // Group bulleted content
            Object.keys(content).forEach(key => {
              const match = key.match(/^(bulleted\d+)\.(heading|text\d+)$/);
              if (match) {
                const [, prefix, type] = match;
                if (!bulletedGroups[prefix]) {
                  bulletedGroups[prefix] = { heading: '', texts: [] };
                }
                if (type === 'heading') {
                  bulletedGroups[prefix].heading = content[key];
                } else if (type.startsWith('text')) {
                  bulletedGroups[prefix].texts.push(content[key]);
                }
              }
            });
            
            // Render bulleted groups
            return Object.keys(bulletedGroups)
              .sort()
              .map(prefix => (
                <div key={prefix} className="space-y-3">
                  {bulletedGroups[prefix].heading && (
                    <h3 className="text-xl font-semibold text-foreground">
                      {bulletedGroups[prefix].heading}
                    </h3>
                  )}
                  {bulletedGroups[prefix].texts.length > 0 && (
                    <ul className="list-disc list-inside space-y-2 pl-4">
                      {bulletedGroups[prefix].texts.map((text, idx) => (
                        <li key={idx} className="whitespace-pre-line">
                          {text}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ));
          })()}
        </div>
      </div>
    </section>
  );
};

export default About;
